import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterMapper, IdentityFilterMapper } from '@app/models/filters/filter-mapper';
import { FilterStatus } from '@app/models/filters/filter-status';
import * as FilterType from '@app/models/filters/filter-type';
import { GenericFilterConfig } from '@app/models/filters/generic-filter-config';
import { AutocompleteTextComponent } from './autocomplete-text/autocomplete-text.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ContextualizedSelectsComponent } from './contextualized/contextualized-selects/contextualized-selects.component';
import { RadioComponent } from './radio/radio.component';
import { ExclusiveFiltersComponent } from './exclusive-filters/exclusive-filters.component';

@Component({
	selector: 'app-filter-group',
	standalone: true,
	imports: [
		RadioComponent,
		CheckboxComponent,
		ContextualizedSelectsComponent,
		AutocompleteTextComponent,
		ExclusiveFiltersComponent,
	],
	templateUrl: './filter-group.component.html',
	styleUrl: './filter-group.component.css',
})
export class FilterGroupComponent {
	@Input() filters: GenericFilterConfig[] = [];
	@Input() asAccordion: boolean = false;
	@Input() filterMapper: FilterMapper = new IdentityFilterMapper();

	@Output() filterChanged = new EventEmitter<FilterStatus>();
	@Output() selectedExclusiveFilter = new EventEmitter<string>();

	filterType = FilterType;

	onFilterChange = (newStatus: FilterStatus) => {
		this.filterChanged.emit(this.filterMapper.mapValues(newStatus));
	};

	onExclusiveFilterSelection = (previouslySelectedId: string) => {
		this.selectedExclusiveFilter.emit(previouslySelectedId);
	};
}
